import axiosClient from "sharedServices/api/axios.services";
import { IApiBaseResponse } from "models/interfaces/Iglobal";
import { InventoryPricingIssueRes, LongInventoryData, PricingResolutionMasterData } from "models/interfaces";
import { SkyBoxRoutesEnum } from "models/enums/apiRoutes/skyBoxApiRoutes";
import { longInventoryType } from "models/types";

class LongInventoryService {
    public longInventoryData = async (longInventoryRequest: longInventoryType) => {
        return axiosClient.get<IApiBaseResponse<LongInventoryData>
        >(SkyBoxRoutesEnum.LONG_INVENTORY, {
            params: longInventoryRequest
        })
    }
    public getPricingResolution = async () => {
        return axiosClient.get<IApiBaseResponse<PricingResolutionMasterData[]>
        >(SkyBoxRoutesEnum.PRICING_RESOLUTIONS, {
            params: null
        })
    }
    
    public savePricingResolution = async (inventoryPricingIssueRes: InventoryPricingIssueRes) => {
        return axiosClient.patch<IApiBaseResponse<boolean>>(
          SkyBoxRoutesEnum.SAVE_PRICING_RESOLUTIONS,
          {
            ...inventoryPricingIssueRes,
          }
        );
      };
}

export { LongInventoryService }